import axios from '@/plugins/axios'
import store from '@/store'

const createShortUrl = async url => {
  try {
    const params = {}
    params.url = url
    const response = await axios.post(process.env.VUE_APP_SHORTENER_URL, params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getPosts = async function ({
  userId = null,
  tagId = null,
  categoryId = null,
  groupId = null,
  postType = null,
  visibility = null,
  license = null,
  status = null,
  search = null,
  excludedId = null,
  isPublicDomain = null,
  page = 1
}) {
  try {
    const params = {}
    if (userId) params.user_id = userId
    if (tagId) params.tag_id = tagId
    if (categoryId) params.category_id = categoryId
    if (groupId) params.group_id = groupId
    if (postType) params.type = postType
    if (visibility) params.visibility = visibility
    if (license) params.license = license
    if (status !== null) params.status = status
    if (search) params.search = search
    if (excludedId) params.excluded_id = excludedId
    if (isPublicDomain) params.is_public_domain = isPublicDomain
    params.page = page

    const response = await axios.get('posts', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getPost = async slug => {
  try {
    const response = await axios.get(`posts/${slug}`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

// eslint-disable-next-line camelcase
const post = async (id = null, {
  title = '',
  slug = '',
  description = '',
  // eslint-disable-next-line camelcase
  category_id = '',
  visibility = 'public',
  license = 'cc0',
  content = '',
  type = 'post',
  // eslint-disable-next-line camelcase
  is_comments_enabled = true,
  // eslint-disable-next-line camelcase
  is_sensible = false,
  cover = null,
  // eslint-disable-next-line camelcase
  default_cover = null,
  tags = [],
  // eslint-disable-next-line camelcase
  book_id = null,
  // eslint-disable-next-line camelcase
  group_id = null,
  // eslint-disable-next-line camelcase
  publish_at = null,
  // eslint-disable-next-line camelcase
  publish_method = 'publish',
  // eslint-disable-next-line camelcase
  is_sample = false,
  // eslint-disable-next-line camelcase
  is_silent_publication = false
}, isDraft = false) => {
  // console.log(title, slug, description, categoryId, visibility, content, status, is_comments_enabled, cover)
  if (isDraft) store.dispatch('posts/setSavingDraft', { savingDraft: true })
  else store.dispatch('posts/setPublishing', { publishing: true })
  try {
    const form = new FormData()
    form.append('title', title || '')
    form.append('visibility', visibility)
    form.append('license', license)
    form.append('category_id', category_id)
    if (content) form.append('content', JSON.stringify(content))
    if (isDraft) {
      form.append('status', 'draft')
    } else {
      // eslint-disable-next-line camelcase
      form.append('status', publish_method === 'publish' ? 'published' : 'scheduled')
    }
    // eslint-disable-next-line camelcase
    form.append('is_comments_enabled', is_comments_enabled ? 1 : 0)
    // eslint-disable-next-line camelcase
    form.append('is_sensible', is_sensible ? 1 : 0)
    form.append('type', type)
    // eslint-disable-next-line camelcase
    form.append('is_silent_publication', is_silent_publication ? 1 : 0)
    // eslint-disable-next-line camelcase
    if (publish_method === 'schedule') form.append('publish_at', publish_at)
    if (slug) form.append('slug', slug || '')
    if (description) form.append('description', description || '')
    if (cover) form.append('cover', cover)
    // eslint-disable-next-line camelcase
    if (default_cover) form.append('default_cover', default_cover)
    if (id) form.append('_method', 'PUT')
    if (tags) form.append('tags', tags)
    // eslint-disable-next-line camelcase
    if (book_id) form.append('book_id', book_id)
    // eslint-disable-next-line camelcase
    if (group_id) form.append('group_id', group_id)
    // eslint-disable-next-line camelcase
    form.append('is_sample', is_sample ? 1 : 0)

    const url = id ? `posts/${id}` : 'posts'
    // console.log(url, name, slug, description, visibility, cover)
    const response = await axios.post(url, form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    store.dispatch('posts/setPublishing', { publishing: null })
    store.dispatch('posts/setSavingDraft', { savingDraft: null })
    const { data } = response
    return data
  } catch (error) {
    store.dispatch('posts/setPublishing', { publishing: null })
    store.dispatch('posts/setSavingDraft', { savingDraft: null })
    return Promise.reject(error)
  }
}

const destroyPost = async id => {
  try {
    const response = await axios.post(`posts/${id}`, {
      _method: 'DELETE'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const updateProgress = async (id, progress) => {
  try {
    const params = {
      progress: progress
    }
    const response = await axios.put(`posts/${id}/progress`, params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  updateProgress,
  createShortUrl,
  destroyPost,
  getPosts,
  getPost,
  post
}
